const SIDES = ['top', 'right', 'bottom', 'left'];
const ELEMENT_LABELS = {
  'filter-red': '红色滤光器',
  'filter-green': '绿色滤光器',
  'filter-blue': '蓝色滤光器',
  'mirror-forward': '右斜平面镜',
  'mirror-backward': '左斜平面镜',
  splitter: '分光器'
};
function emptyArray(size) {
  return Array.from({
    length: size
  }, () => null);
}
function normalizeBoard(value) {
  const source = value && typeof value === 'object' ? value : {};
  const arrows = source.arrows && typeof source.arrows === 'object' ? source.arrows : {};
  return {
    cells: Array.from({
      length: 25
    }, (_, index) => source.cells?.[index] || null),
    arrows: SIDES.reduce((result, side) => {
      result[side] = Array.from({
        length: 5
      }, (_, index) => arrows[side]?.[index] || null);
      return result;
    }, {})
  };
}
export default {
  name: 'OpticalPathBoard',
  props: {
    modelValue: {
      type: Object,
      default: () => ({
        cells: emptyArray(25),
        arrows: {}
      })
    },
    editableCells: {
      type: Boolean,
      default: false
    },
    editableArrows: {
      type: Boolean,
      default: false
    },
    showElements: {
      type: Boolean,
      default: true
    },
    showArrowSlots: {
      type: Boolean,
      default: true
    },
    activeTool: {
      type: String,
      default: 'filter-red'
    },
    arrowColor: {
      type: String,
      default: 'red'
    },
    compact: {
      type: Boolean,
      default: false
    },
    ariaLabel: {
      type: String,
      default: '光路图'
    }
  },
  emits: ['update:modelValue'],
  computed: {
    board() {
      return normalizeBoard(this.modelValue);
    }
  },
  methods: {
    emitBoard(board) {
      this.$emit('update:modelValue', board);
    },
    updateCell(index) {
      if (!this.editableCells) return;
      const board = normalizeBoard(this.modelValue);
      board.cells[index] = this.activeTool === 'eraser' ? null : this.activeTool;
      this.emitBoard(board);
    },
    updateArrow(side, index) {
      if (!this.editableArrows) return;
      const board = normalizeBoard(this.modelValue);
      const current = board.arrows[side][index];
      if (this.activeTool === 'eraser') {
        board.arrows[side][index] = null;
      } else if (!current) {
        board.arrows[side][index] = {
          color: this.arrowColor,
          direction: 'in'
        };
      } else if (current.color !== this.arrowColor) {
        board.arrows[side][index] = {
          ...current,
          color: this.arrowColor
        };
      } else {
        board.arrows[side][index] = {
          ...current,
          direction: current.direction === 'in' ? 'out' : 'in'
        };
      }
      this.emitBoard(board);
    },
    arrow(side, index) {
      return this.board.arrows[side][index];
    },
    arrowGlyph(side, index) {
      const arrow = this.arrow(side, index);
      if (!arrow) return '';
      const inward = {
        top: '↓',
        right: '←',
        bottom: '↑',
        left: '→'
      };
      const outward = {
        top: '↑',
        right: '→',
        bottom: '↓',
        left: '←'
      };
      return arrow.direction === 'in' ? inward[side] : outward[side];
    },
    arrowClasses(side, index) {
      const arrow = this.arrow(side, index);
      return {
        filled: Boolean(arrow),
        editable: this.editableArrows,
        [`color-${arrow?.color}`]: Boolean(arrow)
      };
    },
    arrowAria(side, index) {
      const sideLabels = {
        top: '上边',
        right: '右边',
        bottom: '下边',
        left: '左边'
      };
      const arrow = this.arrow(side, index);
      if (!arrow) return `${sideLabels[side]}第 ${index + 1} 个箭头位，未设置`;
      const colorLabels = {
        red: '红色',
        green: '绿色',
        blue: '蓝色'
      };
      return `${sideLabels[side]}第 ${index + 1} 个箭头位，${colorLabels[arrow.color]}${arrow.direction === 'in' ? '射入' : '射出'}`;
    },
    cellAria(cell, index) {
      const row = Math.floor(index / 5) + 1;
      const column = index % 5 + 1;
      return `第 ${row} 行第 ${column} 列，${cell ? ELEMENT_LABELS[cell] : '空白'}`;
    }
  }
};